var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('vue-dropzone',{staticClass:"dropzone",attrs:{"id":"dropzone-top","options":_vm.dropzoneOptions},on:{"vdropzone-removed-file":_vm.handleRemove}})}
var staticRenderFns = []

export { render, staticRenderFns }